import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from 'components/Shared/Common/Button';
import Separator from 'components/Shared/Layout/Separator';
import { ESCAPE } from 'const/eventKey';
import { Alert } from 'antd';
import { StyledMessageDrawer } from './style';

export default class FeedDrawer extends PureComponent {
    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        title: PropTypes.node.isRequired,
        onClose: PropTypes.func.isRequired,
        content: PropTypes.element.isRequired,
        error: PropTypes.string,
        action: PropTypes.element,
        enableEscape: PropTypes.bool
    };

    static defaultProps = {
        action: null,
        error: '',
        enableEscape: false
    };

    hasEventListener = false;

    componentDidMount() {
        this.bindEscapeKey();
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.enableEscape && !this.hasEventListener) {
            this.bindEscapeKey();
        }
    }

    componentWillUnmount() {
        if (this.hasEventListener) {
            document.removeEventListener('keydown', this.handleKeyDown);
        }
    }

    bindEscapeKey = () => {
        if (this.props.enableEscape) {
            document.addEventListener('keydown', this.handleKeyDown);
            this.hasEventListener = true;
        }
    };

    handleKeyDown = (e) => {
        if (e.key === ESCAPE || e.keyCode === ESCAPE) {
            this.props.onClose();
        }
    };

    render() {
        const {
            isOpen, title, onClose, content, action, error
        } = this.props;

        return (
            <StyledMessageDrawer
                className={classNames({
                    'message-drawer': true,
                    drawer_open: true,
                    active: isOpen
                })}
                id="feed-drawer"
            >
                <div className="message-drawer-title">
                    <div className="text">{title}</div>
                    <div className="icon">
                        {action && (
                            <>
                                {action}
                                <Separator />
                            </>
                        )}
                        <Button isTransparent iconName="X" onClick={onClose} />
                    </div>
                </div>
                <div className="message-drawer-content">
                    <div className="message-drawer-content-overflow">
                        {error && <Alert type="error" message={error} />}
                        {content}
                    </div>
                </div>
            </StyledMessageDrawer>
        );
    }
}
